import { EXCHANGE_KIND_TEXT } from '@aeris/status-meta'
import type { RadioOption } from '@aeris/ui'

/**
 * Vale ou troca, em dois cartões — o pedido do caixa e o trocador (F136).
 *
 * Os dois diálogos perguntam a mesma coisa ao mesmo cliente; as mesmas palavras
 * nos dois é o que faz o trocador reconhecer o pedido que chegou. O texto mora
 * em `@aeris/status-meta` desde a F306, porque o celular também pede.
 */
export const EXCHANGE_KIND_OPTIONS: readonly RadioOption<
  'voucher' | 'exchange'
>[] = EXCHANGE_KIND_TEXT

/** O `RadioGroup` do kit desenhado como cartões lado a lado. */
export const KIND_CARDS_CLASS =
  'grid grid-cols-1 gap-2 sm:grid-cols-2 [&>label]:rounded-(--radius-md) [&>label]:border [&>label]:border-(--border-default) [&>label]:p-3 [&>label:has([data-state=checked])]:border-(--brand-primary) [&>label:has([data-state=checked])]:bg-(--surface-sunken)'
